import { render, staticRenderFns } from "./AddDiscussionBoard.vue?vue&type=template&id=39f78baa&"
import script from "./AddDiscussionBoard.vue?vue&type=script&lang=js&"
export * from "./AddDiscussionBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports